// extracted by mini-css-extract-plugin
export default {"ComponentContainer":"StudentProjects_ComponentContainer__5k7CL","ProjectActive":"StudentProjects_ProjectActive__YHq0H","ProjectFinished":"StudentProjects_ProjectFinished__7hI0B"};